import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { CareType } from '../../actions';
import { MatchPreference } from '../../resources';


/**
 * @deprecated use `getMatchPreference` by matchId instead
 */
export const getMatchPreferences = () => restClient.request<{
  data: MatchPreference;
}>('/api/v1/onboarding/match_preferences');


export const getMatchPreference = (matchId: string) => restClient.request<{
  data: MatchPreference;
}>(`/api/v1/match/${matchId}/preference`);

export type UpdateMatchPreferencesInput = {
  appointmentType?: CareType;
  recommendedService?: CareType;
  modalityId?: string;
  ageGroupId?: string;
  visitReasonIds?: string[];
  faithIds?: string[];
  genderIds?: string[];
  ethnicityIds?: string[];
  insuranceCompanyId?: string;
  stateId?: string;
  communityExpertise?: {
    faithIds?: string[];
    ethnicityIds?: string[];
    generalIds?: string[];
  };
  directFlowData?: {
    providerId: string;
    appointment: string;
    publicProfileUrl: string;
  };
};

export const updateMatchPreferences = (matchId: string, preferences: UpdateMatchPreferencesInput) => restClient.request(`/api/v1/onboarding/matches/${matchId}/match_preference`, {
  method: 'PATCH',
  data: snakecaseKeys(preferences)
});
